export default defineNuxtRouteMiddleware(async (_, from) => {
	const nuxtApp = useNuxtApp()
	const isLogged = useCookie('is_logged')
	const localePath = useLocalePath()
	const userStore = useUserStore()
	if (!isLogged.value) return navigateTo({ path: localePath('/'), query: { redirectAfter: from.fullPath } })
	else {
		try {
			await userStore.fetchUser()
		} catch (error) {
			console.log(error)
			nuxtApp.runWithContext(() => userStore.logout())
		}
	}
})
